<template>
	<div class="pageWrapper">
		<el-row :gutter="20">
			<el-col :span="10">
				<div class="panel actionPanel">
					<img class="logo" src="../assets/primaryLogo.svg" />
					<div class="otpForm">
						<h1 style="font-weight: bold">Enter OTP</h1>
						<p>Please enter 4 digit otp sent to your email.</p>
						<el-divider></el-divider>
						<el-alert
							v-if="requestSuccess"
							:closable="false"
							style="margin-bottom: 12px"
							title="OTP verified successfully"
							description="Redirecting..."
							type="success"
							show-icon
						>
						</el-alert>
                        <el-alert
							v-if="otpResendSuccess"
							:closable="false"
							style="margin-bottom: 12px"
							title="OTP Resent successfully"
							description="A new verification code has been sent to your email."
							type="success"
							show-icon
						>
						</el-alert>
						<el-alert
							v-if="requestError"
							:closable="false"
							style="margin-bottom: 12px"
							title="OTP verification failed"
							description="The OTP you entered is incorrect or expired. Please try again."
							type="error"
							show-icon
						>
						</el-alert>
						<el-alert
							v-if="otpResendError"
							:closable="false"
							style="margin-bottom: 12px"
							title="Failed to resend OTP"
							description="We were unable to resend the OTP. Please try again."
							type="error"
							show-icon
						>
						</el-alert>
						<el-form
							ref="form"
							@keyup.native.enter="verifyOtp"
							:rules="formRules"
							label-position="top"
							label-width="100px"
							:model="otpForm"
						>
                            <el-form-item prop="otp" label="OTP">
								<el-input
									type="number"
									placeholder="1234"
									maxlength="4"
									v-model="otpForm.otp"
								></el-input>
							</el-form-item>

							<el-form-item style="display: none">
								<el-input></el-input>
							</el-form-item>

                            <el-form-item>
								<el-button
									:disabled="!otpForm.otp || otpForm.otp.length !== 4"
									@click="verifyOtp"
									:loading="operationInProgress"
									style="width:100%;margin-top:12px"
									type="primary"
								>Verify OTP</el-button>
							</el-form-item>

                            <el-form-item>
								<div style="text-align: right">
									<el-button 
                                        @click="resendOtp" 
										:loading="resendOperationInProgress"
                                        type="text"
                                        style="position:relative"
										>Resend OTP
                                    </el-button>
								</div>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
			<el-col :span="14">
				<div class="panel contentPanel"><mediaCarousel /></div>
			</el-col>
		</el-row>
	</div>
</template>
 
<script>
import mediaCarousel from "../components/mediaCarousel.vue";
import { httpHelper } from "../utils/httpHelper.js";
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { isAgiDomain } from "../utils/domainUtil.js";

export default {
    computed: {
		...mapGetters(["getLoginEmail"]),
	},
	components: {
		mediaCarousel,
	},
	data() {
		return {
			requestSuccess: false,
            otpResendSuccess: false,
			otpResendError: false,
			requestError: false,
			operationInProgress: false,
			resendOperationInProgress: false,
			otpForm: { otp: "", email: Vue.$cookies.get("email") || this.getLoginEmail },
			formRules: {
				otp: [
					{ required: true, message: "OTP is required", trigger: "change" },
					{ min: 4, max: 4, message: "OTP must be 4 digits", trigger: "change" },
				],
			},
		};
	},
	methods: {
        ...mapActions(["login2FAMETHOD"]),
		verifyOtp() {
			this.requestError = false
			this.requestSuccess = false
			this.resendOperationInProgress = false
			this.otpResendSuccess = false
			this.otpResendError = false
			this.$refs.form.validate(async (valid) => {
				if (valid) {
					this.operationInProgress = true
                    const result = await this.login2FAMETHOD(this.otpForm);
					setTimeout(() => {
						this.operationInProgress = false
						if (!result?.error) {
							this.requestSuccess = true
							this.requestError = false

							if (Vue.$cookies.get("workflowTourStatus") === "false") {
								localStorage.setItem("workflowTourStartRequested", "true");
							}

							this.$router.push(isAgiDomain() ? "/" : "/workflows").catch(() => {});
						} else {
							this.requestSuccess = false
							this.requestError = true
						}
					}, 500)
				} else {
					return
				}
			})
		},

		async resendOtp() {
			this.requestError = false
			this.requestSuccess = false
            this.otpResendSuccess = false
			this.otpResendError = false
			this.operationInProgress = false
			this.resendOperationInProgress = true
			const result = await httpHelper("RUNTIME", "POST", "security/resendOtp", { email: Vue.$cookies.get("email") || this.getLoginEmail })
            setTimeout(() => {
                this.resendOperationInProgress = false
                if (!result?.error) {
                    this.otpResendSuccess = true
                } else {
                    this.otpResendError = true
                }
            }, 500)
		},
	},
};
</script>

<style scoped>
.pageWrapper {
	height: 100vh;
	width: 100vw;
	text-align: left;
}

.panel {
	height: 100vh;
	width: 100%;
}

.logo {
	height: 40px;
	margin-left: 20px;
	margin-top: 20px;
}

.actionPanel {
	background-color: white;
}

.contentPanel {
	background-color: black;
}

.otpForm {
	width: 70%;
	max-width: 400px;
	display: block;
	margin: auto;
	margin-top: 15%;
}

.underline {
	height: 8px;
	position: absolute;
	top: 35px;
	left: 0px;
}
</style>
